import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FALLBACK_UPSELLS } from "@/lib/fallbackPackages";

export default function Upsells() {
    const [upsells, setUpsells] = useState(FALLBACK_UPSELLS);

    useEffect(() => {
        api.get("/packages")
            .then((r) => {
                if (Array.isArray(r.data?.upsells) && r.data.upsells.length > 0) {
                    setUpsells(r.data.upsells);
                }
            })
            .catch(() => {
                // keep fallback
            });
    }, []);

    return (
        <section
            className="relative py-20 px-6 md:px-12 border-t border-white/5"
            data-testid="upsells-section"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <div>
                        <span className="font-body text-xs uppercase tracking-[0.4em] text-amber-400/80">
                            Services à la carte
                        </span>
                        <h2 className="mt-3 font-display text-3xl md:text-4xl font-light tracking-tighter text-white">
                            Ajoutez ce qu'il vous faut.
                        </h2>
                    </div>
                    <p className="max-w-md text-sm text-zinc-500 font-body">
                        Complétez n'importe quelle formule avec des services
                        supplémentaires pour maximiser la portée de votre contenu.
                    </p>
                </div>

                <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {upsells.map((u, i) => (
                        <motion.div
                            key={u.id}
                            initial={{ opacity: 0, y: 15 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: i * 0.08 }}
                            className="group p-6 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-amber-400/30 hover:bg-white/[0.05] transition-all"
                            data-testid={`upsell-card-${u.id}`}
                        >
                            <div className="flex items-start justify-between">
                                <Plus
                                    className="w-5 h-5 text-amber-400 group-hover:rotate-90 transition-transform duration-500"
                                    strokeWidth={1.5}
                                />
                                <span className="font-display text-xl text-white font-light">
                                    +{u.price}€
                                </span>
                            </div>
                            <h3 className="mt-6 font-display text-lg text-white font-medium">
                                {u.name}
                            </h3>
                            <p className="mt-2 text-sm text-zinc-500 leading-relaxed">
                                {u.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
